import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from 'src/app/app.component';
import { Utilerias } from 'src/app/helpers/Utilerias';
declare var $ : any;

@Component({
  selector: 'app-checklist-paso1',
  templateUrl: './checklist-paso1.component.html',
  styleUrls: ['./checklist-paso1.component.css']
})
export class ChecklistPaso1Component implements OnInit {
  subMenus: { active: boolean; child: boolean; label: string; router: string; class: string; }[];
  title: string;
  item: any;
  checklistName: string;
  ponderacion: number;
  orden: number;
  idChecklist: number;
  idTipoRevision: number;
  constructor(private activatedRoute: ActivatedRoute, private http: HttpClient, private router: Router, private father: AppComponent) {


      father.moduleName = 'Configuracion';

    this.idChecklist = parseInt(this.activatedRoute.snapshot.params.id);
    this.idTipoRevision = parseInt(this.activatedRoute.snapshot.params.idrevision);
    this.title = 'Checklist paso 1'
    this.item = {
      Nombre: '',
      Ponderacion: 100,
      Orden: null
    };
    if (this.idChecklist > 0) {
      this.getChecklist(this.idChecklist)
      .then((res) => {
        this.item = res;
        Utilerias.showLoader(false);
      });
    }
   }

  ngOnInit() {
    this.loadSubMenu();
    localStorage['ponderacion'] = $('#Ponderacion').val();
  }

  formPostPaso1(e: Event) {
    e.preventDefault();
    let obj = {
      c: {
        IdChecklist: this.idChecklist,
        IdTipoRevision: this.idTipoRevision,
        Nombre: $('#Nombre').val(),
        Ponderacion: $('#Ponderacion').val(),
        Orden: $('#Orden').val()
      }
    };
    Utilerias.httpRequest(this.http, 'SetChecklist', 'post', obj)
      .then((res: any) => {
        this.router.navigate(['Configuracion/ChecklistPaso2', res.IdChecklist, this.idTipoRevision]);

        localStorage['ponderacion'] = res.Ponderacion;
      });
  }

  getChecklist(idChecklist){
    return Utilerias.httpRequest(this.http, 'GetChecklist', 'get', { idChecklist: idChecklist });
  }

  loadSubMenu() {
    var items = [
      {
        active: false,
        child: true,
        label: 'Tipos de revisiones',
        router: '../../../../Configuracion',
        class: 'submenu__item d-flex align-items-center'
      },
      {
        active: true,
        child: false,
        label: 'Paso 1',
        router: null,
        class: 'submenu__item submenu--active d-flex align-items-center'
      }];
    this.subMenus = items;
  }
}
